// import the necessary modules
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeWords'
})
export class CapitalizeWordsPipe implements PipeTransform {
  transform(value: string): string {
    if (typeof value !== 'string') {
      return value;
    }

    // Capitalize the first letter
    const capitalizedFirstLetter = value.charAt(0).toUpperCase();

    // Get the remaining part of the string
    const remainingString = value.slice(1);

    // Combine the capitalized first letter and the remaining string
    return capitalizedFirstLetter + remainingString;
  }
}